import {OptionType} from "../../../types/ChainService";
import {HistoricalOptionRecord} from "../../price/historical/HistoricalPriceModels";

export class OptionPair {

    private constructor(public readonly put: HistoricalOptionRecord,
                        public readonly call: HistoricalOptionRecord) {

    }

    public get(type: OptionType): HistoricalOptionRecord {
        if (type === OptionType.PUT) {
            return this.put;
        } else if (type === OptionType.CALL) {
            return this.call;
        } else {
            throw Error(`Unknown Option Type ${type}`);
        }
    }

    public static of(put: HistoricalOptionRecord, call: HistoricalOptionRecord) {
        return new OptionPair(put, call);
    }
}
